import { Component, OnInit, ViewChild, APP_ID, HostBinding, ContentChild, DOCUMENT, InjectionToken } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BtnCellRendererDelete } from 'src/app/core/grid/btn-cell-render-delete.component';
import { BtnCellRendererSave } from 'src/app/core/grid/btn-cell-render-save.component';
import { Inject, TemplateRef } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddTeamDialogComponent } from 'src/app/core/dialogs/add-team-dialog/add-team-dialog.component';
import { DeleteCategoryDialogComponent } from 'src/app/core/dialogs/delete-category-dialog/delete-category-dialog.component';
import { DeleteTeamDialogComponent } from '../../core/dialogs/delete-team-dialog/delete-team-dialog.component';
import { GridTextEditorComponent } from 'src/app/core/grid/grid-text-edit.component'
import { TeamsService } from 'src/app/service/teams.service';
import { UsersService } from 'src/app/service/users.service';
import { GridOptions } from 'ag-grid-community';
import { FormControl } from '@angular/forms';
import { ReplaySubject, startWith, map, debounceTime, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag'; // NOSONAR
import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { GET_FGA_AM_USER_DATA } from 'src/app/constants';
import { environment } from 'src/environments/environment';
export const FGA_API_ENDPOINT = new InjectionToken<string>('FGA_API_ENDPOINT');
export interface DialogData {
	teamName;
	page;
}
export interface deleteData {
	id: Number;
	primary_user: string;
	page;
}
@Component({
	selector: 'app-teams',
	templateUrl: './teams.component.html',
	styleUrls: ['./teams.component.scss'],
	standalone: false,// NOSONAR  
	providers: [{ provide: FGA_API_ENDPOINT, useValue: environment.APM_DS_URI }]
})
export class TeamsComponent implements OnInit {
	gridApi: any;
	gridColumnApi: any
	gridOptions: GridOptions;
	setPagination = 'true';
	defaultColDef;
	paginationPageSize: number = 30;
	currentPageNo: any;
	currentPageBoolean: boolean = false;
	totalPage: any;
	currentPageForTotalPage: any;
	isLastPageFound: any;
	eIconGui;
	rowCount;
	addNewRowData;
	columnDefsUsr;
	columnDefsLogistics;
	icons;
	frameworkComponents;
	context: any;
	selectedRows: any = [];
	successMessage = '';
	errorMessage = '';
	rowDataUsr = [];
	rowDataLogistics = [];
	teamChosen;
	teams;
	userID;
	usertemp: string;
	userInfo: any;
	enableData: boolean = false;
	userData = [];
	userChosen;
	userdropdownTemp: any = [];
	userdropdown: any = [];
	temp2: string;
	teamuserData = [];
	AMChosen;
	selectedRegions: any = [];
	selectedRegionsTemp: any = [];
	temp3;
	regionList;
	@ViewChild('agGrid', { static: true }) agGrid
	userDataTemp: any;
	netTemp = [];
	selected_region;
	lpTemp: any[];
	AMdropdown;
	AMTemp;
	regionsTemp;
	primaryUserToSave;
	secondaryUserToSave; const_deleted = 'Deleted Row(s) Successfully!'
	teamList = 'teams-List'
	LPlocalStorage;
	teamChosenValue;
	deletedTeam: boolean;
	dynamicHeight: number;
	dynamicHeightCard: number;
	teamFilter: FormControl = new FormControl('');
	filteredTeams = new BehaviorSubject<any[]>([]);
	managerFilter: FormControl = new FormControl('');
	filteredManager = new BehaviorSubject<any[]>([]);
	userFilter: FormControl = new FormControl('');
	filteredUser = new BehaviorSubject<any[]>([]);
	regionFilter: FormControl = new FormControl('');
	filteredRegion = new BehaviorSubject<any[]>([]);
	private readonly apollo: ApolloClient<NormalizedCacheObject>;
	constructor(public addDialog: MatDialog,
		private readonly teamService: TeamsService,
		public dialog: MatDialog, @Inject(DOCUMENT) _document, private readonly ngxUiLoaderService: NgxUiLoaderService,
		private readonly userService: UsersService, @Inject(FGA_API_ENDPOINT) private readonly endpoint: string) {
		this.dynamicHeight = 0.63 * (window.innerHeight);
		this.dynamicHeightCard = 0.665 * (window.innerHeight);
		this.context = {
			componentParent: this
		};
		// Create the HTTP Link
		const httpLink = createHttpLink({ uri: endpoint });
		// Create the Authorization Link
		const authLink = setContext((_, { headers }) => {
			const token = sessionStorage.getItem('accessToken'); // Retrieve the access token
			return {
				headers: {
					...headers,
					Authorization: token ? `Bearer ${token}` : '',
				},
			};
		});
		// Combine Links
		const link = ApolloLink.from([authLink, httpLink]) as any;
		// Initialize Apollo Client
		this.apollo = new ApolloClient({
			link,
			cache: new InMemoryCache(),
		});
		this.columnDefsUsr = [
			{
				headerName: "NAME", headerClass: "Name", field: "name", cellClass: "cell_name", autowidth: true,
				autoHeight: true
			},
			{
				headerName: "DELETE", field: "user_delete",
				width: 80,
				autoHeight: true, headerClass: "delete",
				cellRenderer: BtnCellRendererDelete,
				cellRendererParams: {
					clicked: function (_field: any, _act: any) {
					}
				}
			}];
		this.frameworkComponents = {
			btnCellRenderer: BtnCellRendererDelete
		};
		this.defaultColDef = {
			wrapText: true
		};
		this.icons = {
			sortUnSort: '<i class="fa fa-sort" style="font-weight:bold;color:black;"/>',
		};
	}
	sizeToFit() { this.gridApi.sizeColumnsToFit(); }
	goToNexpage() { this.gridApi.paginationGoToNextPage(); }
	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }
	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }
	goToLastPage() { this.gridApi.paginationGoToLastPage() }
	onPageSizeChanged(event: any) { this.gridApi.paginationSetPageSize(Number(event.target.value)); }
	getCurrentPage(): boolean {
		if (this.currentPageNo == 0) { // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}
	isLastPage(): boolean {
		if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}
	onGridReady(params: any) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();
	}
	onDemandsCellValueChanged(params: any) {
		this.gridApi = params.api;
		this.gridApi.sizeColumnsToFit();
	}
	openDialog(): void {
		console.info("open dialog");
		const dialogRef = this.dialog.open(AddTeamDialogComponent, {
			disableClose: true,
			width: '401px',
			data: {}
		});
		dialogRef.afterClosed().subscribe(result => {
			console.info('The dialog was closed', result);
			const dataArr = {
				"teamID": null,
				"description": result.data,
				"networkID": this.userID
			};
			this.teamService.addTeam(dataArr).subscribe(result => {
				console.info("result", result);
				if (!result) {
					this.errorMessage = 'Teams already exists!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 5000);
				}
				else if (result) {
					this.teamChosenValue = JSON.parse(result).teamID;
					this.loadTeam();
					this.successMessage = 'Teams added successfully!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 5000);
				}
			});
		});
	}
	deleteTeamDialog(): void {
		let teamName;
		const tem = this.teamChosenValue;
		this.teams.filter(x => x.teamID == tem).forEach(element => { // NOSONAR
			teamName = element.description;
		});
		const dialogRef = this.dialog.open(DeleteTeamDialogComponent, {
			disableClose: true,
			width: '401px',
			data: { "teamName": teamName }
		});
		dialogRef.afterClosed().subscribe(result => {
			console.info('The dialog was closed', result);
			if (result.data) {
				// if no user is assigned, delete
				// else show warning message
				this.ngxUiLoaderService.start("loader-01");
				this.teamService.deleteTeam(this.teamChosenValue).subscribe(_result => {
					this.successMessage = this.const_deleted;
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					this.enableData = false;
					//fetch latest row data after deleting
					this.deletedTeam = true;
					this.loadTeam();
				});
			}
		});
	}
	deleteUserRow(params) {
		this.ngxUiLoaderService.start("loader-01");
		// delete the user from LP data in DB as well
		const LPUsers = [];
		// LP table
		this.teamService.getLPList(this.teamChosenValue).subscribe(result => {
			if (!result) {
				this.ngxUiLoaderService.stop("loader-01");
			}
			else if (result) {
				let LPobj;
				result.forEach(element => {
					LPobj = {
						"teamID": undefined,
						"LPdetails": {
							"region": undefined,
							"primaryUser": undefined,
							"secondaryUser": undefined
						}
					};
					// local storage for LP
					LPobj.teamID = this.teamChosenValue;
					LPobj.LPdetails.region = element.logisticsPoint;
					LPobj.LPdetails.primaryUser = element.primaryNetworkID;
					LPobj.LPdetails.secondaryUser = element.secondaryNetworkID;
					LPUsers.push(LPobj);
				});
				LPUsers.forEach(element => {
					let dataArr;
					if ((element.teamID == this.teamChosenValue && element.LPdetails.primaryUser == params.data.networkID) && (element.teamID == this.teamChosenValue && element.LPdetails.secondaryUser == params.data.networkID)) { // NOSONAR
						dataArr = {
							"teamID": this.teamChosenValue,
							"logisticsPoint": element.LPdetails.region,
							"primaryNetworkID": 0,
							"secondaryNetworkID": 0
						};
					}
					else if (element.teamID == this.teamChosenValue && element.LPdetails.primaryUser == params.data.networkID) { // NOSONAR
						// reset primary user
						dataArr = {
							"teamID": this.teamChosenValue,
							"logisticsPoint": element.LPdetails.region,
							"primaryNetworkID": 0,
							"secondaryNetworkID": element.LPdetails.secondaryUser
						};
					}
					else if (element.teamID == this.teamChosenValue && element.LPdetails.secondaryUser == params.data.networkID) { // NOSONAR
						// reset secondary user
						dataArr = {
							"teamID": this.teamChosenValue,
							"logisticsPoint": element.LPdetails.region,
							"primaryNetworkID": element.LPdetails.primaryUser,
							"secondaryNetworkID": 0
						};
					}
					else {
						dataArr = {
							"teamID": this.teamChosenValue,
							"logisticsPoint": element.LPdetails.region,
							"primaryNetworkID": element.LPdetails.primaryUser,
							"secondaryNetworkID": element.LPdetails.secondaryUser
						};
					}
					this.teamService.saveLPRow(dataArr).subscribe(_result => {
						this.successMessage = 'Saved Row Successfully!';
						setTimeout(() => {
							this.successMessage = '';
							this.errorMessage = '';
						}, 6500);
						//fetch latest row data after deleting
						// this.loadData();
					});
				});
				this.teamService.deleteUser(this.teamChosenValue, params.data.networkID).subscribe(_result => {
					this.successMessage = this.const_deleted;
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					//fetch latest row data after deleting
					this.loadData();
				});
			}
		});
	}
	deleteLPRow(params) {
		this.ngxUiLoaderService.start("loader-01");
		this.teamService.deleteLP(this.teamChosenValue, params.data.logisticspoint).subscribe(_result => {
			this.successMessage = this.const_deleted;
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			//fetch latest row data after deleting
			this.loadData();
		});
	}
	saveUserinLPRow(column, value, region) {
		let primaryUser = '';
		let secondaryUser = '';
		const LPUsersBefore = JSON.parse(localStorage.getItem('LPUsers'));
		if (column == "primary") { // NOSONAR
			primaryUser = value;
			LPUsersBefore?.filter(x => x.teamID == this.teamChosenValue && x.LPdetails.region == region).forEach(element => { // NOSONAR
				secondaryUser = element.LPdetails.secondaryUser;
			});
		}
		else if (column == "secondary") { // NOSONAR
			secondaryUser = value;
			LPUsersBefore?.filter(x => x.teamID == this.teamChosenValue && x.LPdetails.region == region).forEach(element => { // NOSONAR
				primaryUser = element.LPdetails.primaryUser;
			});
		}
		const LPusers = [];
		if (LPUsersBefore.length > 0) {
			LPUsersBefore.forEach(element => {
				if (element.teamID == this.teamChosenValue && element.LPdetails.region == region) { // NOSONAR
					LPusers.push(
						{
							"teamID": this.teamChosenValue,
							"LPdetails": {
								"region": region,
								"primaryUser": primaryUser,
								"secondaryUser": secondaryUser
							}
						}
					);
				}
				else {
					LPusers.push(
						{
							"teamID": element.teamID,
							"LPdetails": {
								"region": element.LPdetails.region,
								"primaryUser": element.LPdetails.primaryUser,
								"secondaryUser": element.LPdetails.secondaryUser
							}
						}
					);
				}
			});
		}
		localStorage.setItem('LPUsers', JSON.stringify(LPusers));
	}
	saveLPRow(params) {
		const LPUsers = JSON.parse(localStorage.getItem('LPUsers'));
		LPUsers.filter(x => x.teamID == this.teamChosenValue && x.LPdetails.region == params.data.logisticspoint).forEach(element => { // NOSONAR
			this.primaryUserToSave = element.LPdetails.primaryUser;
			this.secondaryUserToSave = element.LPdetails.secondaryUser;
		});
		const dataArr = {
			"teamID": this.teamChosenValue,
			"logisticsPoint": params.data.logisticspoint,
			"primaryNetworkID": this.primaryUserToSave,
			"secondaryNetworkID": this.secondaryUserToSave
		};
		this.ngxUiLoaderService.start("loader-01");
		this.teamService.saveLPRow(dataArr).subscribe(_result => {
			this.successMessage = 'Saved Row Successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			//fetch latest row data after deleting
			this.loadData();
		});
	}
	addLogistics() {
		if (!this.selected_region) {
			this.errorMessage = 'Please select a Logistic Point!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
		}
		else {
			// adding LP in DB
			//this.rowDataUsr[0].networkID
			const dataArr =
			{
				"teamID": this.teamChosenValue,
				"logisticsPoint": this.selected_region.value,
				"primaryNetworkID": 0,
				"secondaryNetworkID": 0
			};
			this.ngxUiLoaderService.start("loader-01");
			this.teamService.addLP(dataArr).subscribe(result => {
				console.info("result", result);
				if (!result) {
					this.errorMessage = 'Logictic Point already exists!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					this.ngxUiLoaderService.stop("loader-01");
				}
				else if (result) {
					this.successMessage = 'Logistic Point added successfully!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					this.loadData();
				}
			});
		}
	}
	addUser() {
		if (this.userChosen == '' || !this.userChosen) { // NOSONAR
			this.errorMessage = 'Please select an User!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
		}
		else {
			// adding user in DB
			const dataArr = {
				"teamID": this.teamChosenValue,
				"networkID": this.userChosen.value
			};
			this.ngxUiLoaderService.start("loader-01");
			this.teamService.addUser(dataArr).subscribe(result => {
				console.info("result", result);
				if (!result) {
					this.errorMessage = 'User already exists!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					this.ngxUiLoaderService.stop("loader-01");
				}
				else if (result) {
					this.successMessage = 'User added successfully!';
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
					this.loadData();
				}
			});
		}
	}
	ngOnInit(): void {
		const userData = sessionStorage?.getItem('FGA');
		if (userData) {
			this.userID = JSON.parse(userData)?.user?.userPrincipalName;
		}
		this.loadTeam();
		this.getAMdropdown();
		this.teamFilter.valueChanges.pipe(
			debounceTime(200),
			startWith(''),
			map(search => search ? this.filterteams(search) : this.AMdropdown?.slice() || []),
		).subscribe(filtered => {
			this.filteredTeams.next(filtered);
		});
		this.managerFilter.valueChanges.pipe(
			debounceTime(200),
			startWith(''),
			map(search => search ? this.filtermanager(search) : this.AMdropdown?.slice() || []),
		).subscribe(filtered => {
			this.filteredManager.next(filtered);
		});
		this.userFilter.valueChanges.pipe(
			debounceTime(200),
			startWith(''),
			map(search => search ? this.filterUser(search) : this.userdropdown?.slice() || []),
		).subscribe(filtered => {
			this.filteredUser.next(filtered);
		});
		this.regionFilter.valueChanges.pipe(
			debounceTime(200),
			startWith(''),
			map(search => search ? this.filterRegion(search) : this.selectedRegions?.slice() || []),
		).subscribe(filtered => {
			this.filteredRegion.next(filtered);
		});
	}
	filterteams(search: string): any[] {
		const lowerSearch = search.toLowerCase();
		return this.teams.filter(user =>
			user.label?.toLowerCase().includes(lowerSearch)
		);
	}
	filtermanager(search: string): any[] {
		const lowerSearch = search.toLowerCase();
		return this.AMdropdown.filter(user =>
			user.label?.toLowerCase().includes(lowerSearch)
		);
	}
	filterUser(search: string): any[] {
		const lowerSearch = search.toLowerCase();
		return this.userdropdown.filter(user =>
			user.label?.toLowerCase().includes(lowerSearch)
		);
	}
	filterRegion(search: string): any[] {
		const lowerSearch = search.toLowerCase();
		return this.selectedRegions.filter(user =>
			user.label?.toLowerCase().includes(lowerSearch)
		);
	}
	refreshData() {
		this.loadData();
	}
	teamChange() {
		this.teamChosenValue = this.teamChosen.value;
		if (this.teamChosenValue) {
			this.enableData = true;
			this.loadData();
		}
		else {
			this.enableData = false;
		}
		// team change
		const teamList = JSON.parse(localStorage.getItem(this.teamList));
		let manager;
		// teamList.filter(x => x.teamID == this.teamChosenValue).forEach(element => {
		// });
		console.info("this.AMdropdown", this.AMdropdown);
		console.info("teamList", teamList);
		this.AMChosen =
			this.AMdropdown.find(x =>
				x.value ===
				teamList.find(t => t.teamID == this.teamChosenValue)?.networkID // NOSONAR
			) ?? null;
		console.info("this.AMChosen", this.AMChosen);
		this.selected_region = undefined;
		this.userChosen = undefined;
	}
	loadTeam() {
		this.teamService.getTeamsList().subscribe(result => {
			console.info("result", result);
			if (!result) {
				localStorage.setItem(this.teamList, '[{}]');
				this.ngxUiLoaderService.stop("loader-01");
			}
			else if (result) {
				const resTemp = [];
				result.forEach(element => {
					const obj = { "label": undefined, "description": undefined, "value": undefined, "teamID": undefined, "networkID": undefined };
					obj.label = element.description;
					obj.description = element.description;
					obj.value = element.teamID;
					obj.teamID = element.teamID;
					obj.networkID = element.networkID;
					resTemp.push(obj);
				});
				console.info("the res temp", resTemp);
				this.teams = resTemp;
				this.filteredTeams.next(this.teams.slice());
				localStorage.setItem(this.teamList, JSON.stringify(result));
				if (this.teamChosenValue) {
					this.teamChosen = this.teams?.find(x => x.teamID == this.teamChosenValue) // NOSONAR
				}
				//fetch latest row data after adding
				this.ngxUiLoaderService.stop("loader-01");
			}
		});
		if (this.teamChosenValue && !this.deletedTeam) {
			this.enableData = true;
			this.loadData();
		}
		this.deletedTeam = false;
	}
	loadData() {
		let currentTeam;
		this.teamService.getTeamsList().subscribe(resultTeam => {
			if (resultTeam) {
				currentTeam = resultTeam.filter(x => x.teamID == this.teamChosenValue); // NOSONAR
				console.info("current team to check in QA", currentTeam);
				console.info("team chosen to check in QA", this.teamChosen);
				this.teamuserData = [];
				this.userData = [];
				this.netTemp = [];
				this.userdropdownTemp = [];
				this.userdropdown = [];
				this.AMdropdown = [];
				this.ngxUiLoaderService.start("loader-01");
				// hitting API instead of fetching from local storage
				const result1: any = localStorage.getItem('users-data');
				const result2 = JSON.parse(result1);
				const finalUsers = result2
					// .filter(u =>
					// 	(u.roles ?? []).some(role =>
					// 		role.toLowerCase().includes("task manager admin".toLowerCase()) ||
					// 		role.toLowerCase().includes("task manager user".toLowerCase())
					// 	)
					// )
					.map(u => ({
						userId: u.userId,
						userPrincipalName: u.userPrincipalName,
						email: u.email,
						displayName: u.displayName,
						firstName: u.firstName,
						lastName: u.lastName
						//	, isAdmin: (u.roles ?? []).some(role =>	role.toLowerCase() == "task manager admin".toLowerCase())
					}));
				const payload = {
					"teamId": this.teamChosenValue,
					"users": finalUsers
				}
				if (result2 && result2.length > 0) {
					this.userData = result2;
					// }
					// 	else {
					// 		setTimeout(() => {
					// 			this.successMessage = '';
					// 			this.errorMessage = '';
					// 		}, 6500);
					// 	}
					// });
					this.userService.getRegionDetails().subscribe(resultRegion => {
						if (resultRegion && resultRegion.length > 0) {
							this.regionList = resultRegion;
							// }
							// 	else {
							// 		setTimeout(() => {
							// 			this.successMessage = '';
							// 			this.errorMessage = '';
							// 		}, 6500);
							// 	}
							// });
							// users table
							this.teamService.getUsersList(payload).subscribe(resultUser => {
								console.info(typeof resultUser, "typeof")
								if (!resultUser) {
									this.ngxUiLoaderService.stop("loader-01");
								}
								else if (resultUser) {
									let obj;
									resultUser.forEach(element => {
										obj = { "networkID": element.networkID, "name": element.firstName + ' ' + element.lastName };
										this.teamuserData.push(obj);
										this.netTemp.push(element.networkID);
									});
									this.rowDataUsr = this.teamuserData;
									// user dropdown
									// temp array, logic to remove the ones in user table ..
									this.userData?.filter(x => !this.netTemp.includes(x.userPrincipalName)).forEach(element => {
										const obj = { "label": element.firstName + ' ' + element.lastName, "value": element.userPrincipalName };
										this.userdropdownTemp.push(obj);
									});
									this.userdropdown = this.userdropdownTemp;
									this.filteredUser.next(this.userdropdown.slice());
									// simply displaying all the users in dropdown
									// col def of LP
									this.columnDefsLogistics = [
										{
											headerName: "LOGISTICS POINT", headerClass: "Logistics Point", field: "logisticspoint",
											cellClass: "cell_Logisticspoint", autowidth: true, autoHeight: true
											// width: 220,
										},
										{
											headerName: "PRIMARY", field: "primary",
											width: 180, autoHeight: true, headerClass: "primary",
											cellRenderer: GridTextEditorComponent,
											cellRendererParams: { column: 'primary', userData: this.rowDataUsr }
										},
										{
											headerName: "SECONDARY", field: "secondary",
											width: 180, autoHeight: true, headerClass: "secondary",
											cellRenderer: GridTextEditorComponent,
											cellRendererParams: { column: 'secondary', userData: this.rowDataUsr },
										},
										{
											headerName: "SAVE", field: "save",
											width: 80, autoHeight: true, headerClass: "save",
											cellRenderer: BtnCellRendererSave,
											cellRendererParams: {
												clicked: function (_field: any, _act: any) {
												}
											}
										},
										{
											headerName: "DELETE", field: "lp_delete",
											width: 80, autoHeight: true, headerClass: "delete",
											cellRenderer: BtnCellRendererDelete,
											cellRendererParams: {
												clicked: function (_field: any, _act: any) {
												}
											}
										}
									];
									//fetch latest row data after adding
									this.ngxUiLoaderService.stop("loader-01");
								}
							});
							// populate the lp table 
							this.getLPTable();
							this.getAMdropdown();
						}
					});
					// closing user API
				}
				else {
					setTimeout(() => {
						this.successMessage = '';
						this.errorMessage = '';
					}, 6500);
				}
				// closing LP API
			}
			else {
				setTimeout(() => {
					this.successMessage = '';
					this.errorMessage = '';
				}, 6500);
			}
		});
	}
	getLPTable() {
		this.lpTemp = [];
		this.LPlocalStorage = [];
		// LP table
		this.teamService.getLPList(this.teamChosenValue).subscribe(result => {
			console.info("result - LP", result);
			if (!result) {
				this.ngxUiLoaderService.stop("loader-01");
			}
			else if (result) {
				let obj;
				let LPobj;
				result.forEach(element => {
					obj = { "logisticspoint": undefined, "primary": undefined, "secondary": undefined };
					LPobj = {
						"teamID": undefined,
						"LPdetails": {
							"region": undefined,
							"primaryUser": undefined,
							"secondaryUser": undefined
						}
					};
					obj.logisticspoint = element.logisticsPoint;
					// saving the ids here to pu & su
					obj.primary = element.primaryNetworkID;
					obj.secondary = element.secondaryNetworkID;
					this.lpTemp.push(obj);
					// local storage for LP
					LPobj.teamID = this.teamChosenValue;
					LPobj.LPdetails.region = element.logisticsPoint;
					LPobj.LPdetails.primaryUser = element.primaryNetworkID;
					LPobj.LPdetails.secondaryUser = element.secondaryNetworkID;
					this.LPlocalStorage.push(LPobj);
				});
				this.rowDataLogistics = this.lpTemp;
				localStorage.setItem('LPUsers', JSON.stringify(this.LPlocalStorage));
				// we are going to remove the regions already selected!
				this.regionsTemp = [];
				this.selectedRegionsTemp = [];
				this.selectedRegions = [];
				this.rowDataLogistics.forEach(element => {
					this.regionsTemp.push(element.logisticspoint);
				});
				this.regionList?.filter(x => !this.regionsTemp.includes(x.region_code)).forEach(element => {
					const obj = { "label": element.region, "value": element.region_code };
					this.selectedRegionsTemp.push(obj);
				});
				this.selectedRegions = this.selectedRegionsTemp;
				this.filteredRegion.next(this.selectedRegions.slice());
				this.ngxUiLoaderService.stop("loader-01");
			}
		});
	}
	updateAM() {
		// hitting the update AM api 
		let teamName;
		const tem = this.teamChosenValue;
		this.teams.filter(x => x.teamID == tem).forEach(element => { // NOSONAR
			teamName = element.description;
		});
		const dataArr = {
			"teamID": this.teamChosenValue,
			"description": teamName,
			"networkID": this.AMChosen.value
		}
		this.teamService.updateAM(dataArr).subscribe(_result => {
			this.successMessage = 'Assistant Manager updated successfully!';
			setTimeout(() => {
				this.successMessage = '';
				this.errorMessage = '';
			}, 6500);
			this.loadTeam();
		});
	}
	async getAMdropdown() {
		this.AMTemp = [{ "label": "None", "value": null }];
		try {
			const result = await this.apollo.query<any>({
				query: GET_FGA_AM_USER_DATA,
				fetchPolicy: 'no-cache',
				errorPolicy: 'all',
				"variables": {
					"firstName": "",
					"lastName": "",
					"middleName": null,
					"userPrincipalName": "",
					"email": "",
					"roles": [
						"Task Manager Admin"
					]
				}
			});
			const data = result?.data?.listUsersByFilters;
			console.info('FGA DATADDDDD:', data);
			if (data && data.length > 0) {
				//storing task data in local
				let obj;
				data.forEach(element => {
					obj = { "label": element.firstName + ' ' + element.lastName, "value": element.userPrincipalName };
					this.AMTemp.push(obj);
				});
				this.AMdropdown = this.AMTemp;
				this.filteredManager.next(this.AMdropdown.slice());
				console.info(this.AMdropdown, "this.AMdropdown")
				console.info(JSON.stringify(result), "JSON.stringify(result)")
				localStorage.setItem('AM-List', JSON.stringify(result));
				this.ngxUiLoaderService.stop("loader-01");
				const teamList = JSON.parse(localStorage.getItem(this.teamList));
				if (teamList.length) {
					this.AMChosen =
						this.AMdropdown.find(x =>
							x.value ===
							teamList.find(t => t.teamID == this.teamChosenValue)?.networkID // NOSONAR
						) ?? null;
				}
			}
			else {
				localStorage.setItem('AM-List', '[{}]');
				this.ngxUiLoaderService.stop("loader-01");
			}
			return true
		} catch (err) {
			console.info('GraphQL query error:', err);
			return false; // ✅ Handle failure gracefully
		}
	}
}